var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2701_46614)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.166016,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#4D4DE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64816 18C9.9428 18 10.2024 17.9059 10.5251 17.7366L18.8101 13.4532C19.4135 13.1397 19.666 12.8951 19.666 12.5C19.666 12.1049 19.4135 11.8666 18.8101 11.5468L10.5251 7.2634C10.2024 7.09407 9.9428 7 9.64816 7C9.0729 7 8.66602 7.3951 8.66602 8.01596V16.984C8.66602 17.6112 9.0729 18 9.64816 18Z",
    fill: "#E1E6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2701_46614"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.166016,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlay);
export default __webpack_public_path__ + "static/media/buttonPlay.9fec0a214717a4ea09cc1c1869df9a3c.svg";
export { ForwardRef as ReactComponent };